import { Link } from "react-router-dom"; 
function Blog () {
     return(
        <>
        {/*
        <!-- =============page banner==================== -->*/}
        <div className="page-banner">
            <div className="container">
                <div className="page-banner-content">
                    <div className="banner-inner">
                        <h2>Blog</h2>
                        <div className="page-route">
                            <a href="">Home </a>
                            <p> / Blog </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/*
        <!-- =============page banner end================ -->*/} 
        {/* =============Blog area ========== */}
        <div className="blog-area cpy-6">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12">
                        <div className="blog-card">
                            <div className="product-card">
                                <div className="product-image">
                                    <a href="" className="product-link">
                                        <img src="assets/img/product/1.png" alt="" className="product" />
                                    </a>
                                    
                                </div>
                                <div className="product-des">
                                    
                                    <div className="buy-like">
                                        <div className="author-info">
                                            <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                            <div className="author-name-type">
                                                <p className="author-type">Creator</p>
                                                <a href="" className="creator-profile">SalvadorDali</a>
                                            </div>
                                        </div>
                                        <div className="price-area">
                                            <p className="price"> Feb 19, 2021</p>
                                        </div>
                                    </div>
                                    <div className="product-title">
                                        <Link to="/post-details">
                                        <a href="" className="blog-link">
                                            The next big trend in crypto
                                        </a>
                                        </Link>
                                        
                                        <p>
                                        Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...
                                        </p>
                                        <a href="" className="custom-btn">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12">
                        <div className="blog-card">
                            <div className="product-card">
                                <div className="product-image">
                                    <a href="" className="product-link">
                                        <img src="assets/img/product/1.png" alt="" className="product" />
                                    </a>
                                </div>
                                <div className="product-des">
                                    
                                    <div className="buy-like">
                                        <div className="author-info">
                                            <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                            <div className="author-name-type">
                                                <p className="author-type">Creator</p>
                                                <a href="" className="creator-profile">SalvadorDali</a>
                                            </div>
                                        </div>
                                        <div className="price-area">
                                            <p className="price"> Feb 19, 2021</p>
                                        </div>
                                    </div>
                                    <div className="product-title">
                                        <a href="" className="blog-link">
                                        The next big trend in crypto
                                        </a>
                                        <p>
                                        Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...
                                        </p>
                                        <a href="" className="custom-btn">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12">
                        <div className="blog-card">
                            <div className="product-card">
                                <div className="product-image">
                                    <a href="" className="product-link">
                                        <img src="assets/img/product/1.png" alt="" className="product" />
                                    </a>
                                    
                                </div>
                                <div className="product-des">
                                    
                                    <div className="buy-like">
                                        <div className="author-info">
                                            <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                            <div className="author-name-type">
                                                <p className="author-type">Creator</p>
                                                <a href="" className="creator-profile">SalvadorDali</a>
                                            </div>
                                        </div>
                                        <div className="price-area">
                                            <p className="price"> Feb 19, 2021</p>
                                        </div>
                                    </div>
                                    <div className="product-title">
                                        <a href="" className="blog-link">
                                        The next big trend in crypto
                                        </a>
                                        <p>
                                        Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...
                                        </p>
                                        <a href="" className="custom-btn">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12">
                        <div className="blog-card">
                            <div className="product-card">
                                <div className="product-image">
                                    <a href="" className="product-link">
                                        <img src="assets/img/product/1.png" alt="" className="product" />
                                    </a>
                                    
                                </div>
                                <div className="product-des">
                                    
                                    <div className="buy-like">
                                        <div className="author-info">
                                            <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                            <div className="author-name-type">
                                                <p className="author-type">Creator</p>
                                                <a href="" className="creator-profile">SalvadorDali</a>
                                            </div>
                                        </div>
                                        <div className="price-area">
                                            <p className="price"> Feb 19, 2021</p>
                                        </div>
                                    </div>
                                    <div className="product-title">
                                        <a href="" className="blog-link">
                                        The next big trend in crypto
                                        </a>
                                        <p>
                                        Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...
                                        </p>
                                        <a href="" className="custom-btn">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12">
                        <div className="blog-card">
                            <div className="product-card">
                                <div className="product-image">
                                    <a href="" className="product-link">
                                        <img src="assets/img/product/1.png" alt="" className="product" />
                                    </a>
                                    
                                </div>
                                <div className="product-des">
                                    
                                    <div className="buy-like">
                                        <div className="author-info">
                                            <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                            <div className="author-name-type">
                                                <p className="author-type">Creator</p>
                                                <a href="" className="creator-profile">SalvadorDali</a>
                                            </div>
                                        </div>
                                        <div className="price-area">
                                            <p className="price"> Feb 19, 2021</p>
                                        </div>
                                    </div>
                                    <div className="product-title">
                                        <a href="" className="blog-link">
                                        The next big trend in crypto
                                        </a>
                                        <p>
                                        Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...
                                        </p>
                                        <a href="" className="custom-btn">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12">
                        <div className="blog-card">
                            <div className="product-card">
                                <div className="product-image">
                                    <a href="" className="product-link">
                                        <img src="assets/img/product/1.png" alt="" className="product" />
                                    </a>
                                    
                                </div>
                                <div className="product-des">
                                    
                                    <div className="buy-like">
                                        <div className="author-info">
                                            <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                            <div className="author-name-type">
                                                <p className="author-type">Creator</p>
                                                <a href="" className="creator-profile">SalvadorDali</a>
                                            </div>
                                        </div>
                                        <div className="price-area">
                                            <p className="price"> Feb 19, 2021</p>
                                        </div>
                                    </div>
                                    <div className="product-title">
                                        <a href="" className="blog-link">
                                        The next big trend in crypto
                                        </a>
                                        <p>
                                        Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...
                                        </p>
                                        <a href="" className="custom-btn">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* =============Blog area end========== */}
        </> 
    ); 
}
export default Blog;